import API_CONFIG, { getHeaders, getApiUrl } from './config';

class MenuService {
  async getMenuItems() {
    try {
      const url = getApiUrl(API_CONFIG.ENDPOINTS.MENU.GET_ITEMS);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getHeaders(true)
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message || 'Failed to fetch menu items');
      }

      const data = responseData.data || responseData;

      return {
        success: true,
        data
      };
    } catch (error) {
      console.error('Get menu items error:', error);
      return {
        success: false,
        error: error.message || 'Network error occurred'
      };
    }
  }

  extractCategories(menuItems) {
    if (!menuItems || !Array.isArray(menuItems)) {
      return [];
    }

    const categoryMap = new Map();
    
    menuItems.forEach(item => {
      if (item.category && !categoryMap.has(item.category)) {
        categoryMap.set(item.category, {
          id: item.category.toLowerCase().replace(/\s+/g, '-'),
          name: item.category
        });
      }
    });

    return Array.from(categoryMap.values());
  }

  groupByCategory(menuItems) {
    if (!menuItems || !Array.isArray(menuItems)) {
      return {};
    }

    return menuItems.reduce((acc, item) => {
      const category = item.category || 'Other';
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(item);
      return acc;
    }, {});
  }
}

export default new MenuService();

